export default "__VITE_ASSET__Dt7TDp_b__"